import logger from "src/logger";

const injectScript = (src, callback) => {
  if (!src) {
    logger.warn("Failed to inject script");
    return;
  }

  if (document.querySelector(`script[src="${src}"]`)) {
    return callback();
  }

  let script = document.createElement("script");
  const prior = document.getElementsByTagName("script")[0];
  script.async = 1;
  prior.parentNode.insertBefore(script, prior);

  script.onload = () => {
    if (callback) {
      callback();
    }
  };

  script.src = src;
};

export default injectScript;
